module.exports = __webpack_public_path__ + "static/media/Apartment-4@2x.0d6d3975.png";